import { type FC, type ReactNode } from 'react';

import { iconButton } from './styles';
import { cx } from '@emotion/css';

interface Props {
	disabled?: boolean;
	children: ReactNode;
	onClick?: (_) => void;
	ariaLabel?: string;
	className?: string;
}

const IconButton: FC<Props> = (props) => {
	const { disabled = false, onClick, children, ariaLabel, className, ...rest } = props;

	return (
		<button
			type="button"
			className={cx(iconButton, className)}
			aria-label={ariaLabel}
			disabled={disabled}
			onClick={onClick}
			{...rest}>
			{children}
		</button>
	);
};

export default IconButton;
